import { createSelector } from 'reselect'

import { EMPTY_ARRAY } from 'utils/emptyConstants'

import { SETUP_STEPS } from './constants'

const selectData = createSelector(
  (state) => state.accountSetup.data,
  // The setup-steps endpoint returns an array; guard against a non-array body
  // (e.g. an error/empty-envelope response) so a bad payload degrades to "no
  // steps" instead of crashing the whole app on `.filter`.
  (items) => (Array.isArray(items) ? items.filter((e) => SETUP_STEPS[e.step]) : EMPTY_ARRAY)
)
const selectLoader = (state) => state.accountSetup.loader
const selectError = (state) => state.accountSetup.error

const selectDoToCount = createSelector(
  selectData,
  (items) => items.filter((elem) => !elem.complete && !elem.dismissed).length
)

const selectStepLoader = (state) => state.accountSetup.stepLoader

export { selectData, selectLoader, selectError, selectDoToCount, selectStepLoader }
